import styled, { css } from 'styled-components';

import { colors } from '@nhl/common-styled-component';

export const Caret = styled.span<{ $highlighted: boolean }>`
    border-color: ${colors.$9} transparent transparent;
    border-style: solid;
    border-width: 5px 5px 2.5px;
    display: inline-block;
    height: 0;
    margin-top: 4px;
    margin-right: 2px;
    width: 0;
    position: relative;

    ${(props) =>
        props.$highlighted &&
        css`
            border-color: ${colors.blue16} transparent transparent;
            border-width: 8px 6px 2.5px;
        `}
`;
